import styled from "styled-components";

export const VideoSlidesTipTextBox = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  font-weight: 200;
  
  p:first-of-type {
    font-weight: 800;
    margin-bottom: 0;
    font-size: 1.8rem;
  }
`;
